import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { PADDING_LEFT_RIGHT_SECTION_MOBILE } from '../../common/pagebuilder.style';
import type { StyleRule } from '@archipro-design/aria';
import type { ColumnDimensionType } from '@modules/page-builder/types';

export const ImageContainer: StyleRule<{
    dimension?: ColumnDimensionType;
    showActionsOnHover?: boolean;
}> = ({ theme, dimension, showActionsOnHover }) => ({
    position: 'relative',
    height: dimension?.mobileHeight ? pxToRem(dimension.mobileHeight) : '100%',
    width: dimension?.mobileWidth ? pxToRem(dimension.mobileWidth) : '100%',
    overflow: 'hidden',
    margin: 'auto',

    [theme.screen.tablet]: {
        height: dimension?.tabletHeight
            ? pxToRem(dimension.tabletHeight)
            : '100%',
        width: dimension?.tabletWidth ? pxToRem(dimension.tabletWidth) : '100%',
        marginTop: pxToRem(0),
    },

    [theme.screen.laptop]: {
        height: dimension?.height ? pxToRem(dimension.height) : '100%',
        width: dimension?.width ? pxToRem(dimension.width) : '100%',
        marginTop: pxToRem(0),
        '& [role="toolbar"]': {
            opacity: showActionsOnHover ? 0 : 1,
        },
        '&:hover [role="toolbar"]': {
            opacity: 1,
        },
    },
});

export const HoverActions: StyleRule = ({ theme }) => ({
    position: 'absolute',
    margin: pxToRem(16),
    bottom: pxToRem(16),
    right: pxToRem(16),
    display: 'flex',
    transition: 'opacity 300ms',
    opacity: 1,
    zIndex: theme.siteVariables.zIndexes.menuItem,
});

export const BackButton: StyleRule = () => ({
    position: 'absolute',
    top: pxToRem(15),
});

export const BannerWrapper: StyleRule<{ showOverlay: boolean }> = ({
    theme,
    showOverlay,
}) => ({
    position: 'relative',
    [theme.screen.laptop]: {
        width: '100%',
        overflow: 'hidden',
    },

    ...(showOverlay && {
        [`&:after`]: {
            content: `''`,
            background: `rgba(0,0,0, 0.3)`,
            display: 'block',
            width: `100%`,
            height: `100%`,
            zIndex: theme.siteVariables.zIndexes.foreground,

            [theme.screen.laptop]: {
                position: 'absolute',
                top: 0,
                left: 0,
            },
        },
    }),
});

export const MobileCaptionContainer: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, PADDING_LEFT_RIGHT_SECTION_MOBILE]),
    [theme.screen.tablet]: {
        padding: 0,
    },

    [`& > div`]: {
        margin: 'auto',
    },
});
